import VxeToolbarComponent from './src/toolbar';
import { dynamicApp } from '../dynamics';
export var VxeToolbar = Object.assign(VxeToolbarComponent, {
    install: function (app) {
        app.component(VxeToolbarComponent.name, VxeToolbarComponent);
    }
});
export var Toolbar = VxeToolbar;
dynamicApp.component(VxeToolbarComponent.name, VxeToolbarComponent);
export default VxeToolbar;
